import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Input } from 'components/Input';

const Container = styled.div`
  display: flex;

  margin: 2.5rem 0;
  padding-bottom: 2rem;

  gap: 30rem;

  border-bottom: 0.3rem solid ${pickColor('gray')};
`;

const Wrapper = styled.div``;

const InputWrapper = styled.div`
  display: flex;
  gap: 1rem;

  margin-top: 2rem;
`;

const EstInput = styled(Input)`
  width: 3rem;
  height: 2.7rem;
`;

export { Container, Wrapper, InputWrapper, EstInput };
